import MenuVariaveisSalesbox from "../MenuVariaveisSalesbox";
import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import PalavraChavePsicografica from "../PalavraChavePsicografica";
import PesquisaArtigo from "../PesquisaArtigo";

export default function VariaveisPsicograficas() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active">
                    <a href="/variaveis-salesbox">Variáveis Sales Box</a>
                  </li>
                  <li className="breadcrumb-item active">
                    Variáveis psicográficas
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuVariaveisSalesbox />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">Variáveis psicográficas</h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Variáveis Sales Box</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Entenda nossas variáveis
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  As variáveis psicográficas referem-se a características ou
                  traços psicológicos, emocionais e comportamentais de um
                  indivíduo. Ao contrário das variáveis demográficas, que se
                  concentram em dados como idade, gênero e renda, as variáveis
                  psicográficas mergulham mais fundo na mente e no coração do
                  consumidor.
                </p>

                <p>
                  Entender as variáveis psicográficas é essencial porque oferece
                  uma visão mais profunda sobre o que motiva os consumidores. Ao
                  conhecer os valores, crenças, personalidade, estilo de vida e
                  interesses de um indivíduo, as empresas podem construir
                  relacionamentos mais sólidos com seus clientes e impulsionar o
                  sucesso de seus negócios.
                </p>

                <p>
                  Na
                  <a href="https://salesbox.com.br/" target="blank">
                    <a className="nav-item"> Sales Box</a>
                  </a>
                  , essas variáveis podem se utilizadas tanto na
                  <a
                    href="/como-criar-uma-segmentacao-de-clientes"
                    target="blank"
                  >
                    <a className="nav-item"> Segmentação de Clientes </a>
                  </a>
                  como na criação de um
                  <a href="/como-criar-um-publico-potencial" target="blank">
                    <a className="nav-item"> Público Potencial</a>
                  </a>
                  .
                </p>

                <p>
                  Importante ressaltar que, para as variáveis de escala númerica
                  utilizamos a progressão gradual, ou seja, à medida que nos
                  movemos de 1 para 100 ou de 1 para 1000, há uma tendência
                  geral de aumento na positividade ou veracidade dos números.
                </p>

                <p>
                  <h3 id="segmentacao">Segmentação Psicográfica</h3>
                </p>

                <p>
                  Veja os tipos de segmentações psicográficas que você pode
                  utilizar.
                </p>

                <p>
                  <a id="segmento" style={{ fontWeight: "bold" }}>
                    {" "}
                    1. Segmento:{" "}
                  </a>
                  Utilize um ou mais de nossos 9 segmentos para criar um público
                  potencial ou combinar novos segmentos.
                </p>

                <p>
                  Escala: "Racional","Tradicional", "Conservador",
                  "Questionador", "Imediatista", "Antenado", "Sofisticado",
                  "Compassível", "Inovadores".
                </p>

                <figure>
                  <img
                    src="img/segmento-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  Conheça mais sobre{" "}
                  <a
                    href="/o-que-sao-as-informacoes-psicograficas-da-sales-box"
                    target="blank"
                  >
                    <a className="nav-item">
                      {" "}
                      o que são as informações psicográficas da Sales Box.{" "}
                    </a>
                  </a>
                </p>

                <p>
                  <a id="neuroticismo" style={{ fontWeight: "bold" }}>
                    {" "}
                    2. Propensão ao Neuroticismo:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial que tenha uma tendência a experimentar emoções
                  negativas.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/neuroticismo-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="experiencia" style={{ fontWeight: "bold" }}>
                    {" "}
                    3. Propensão de Abertura à Experiência:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial que está disposto a explorar novas ideias, valores,
                  sensações e experiências.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/abertura-experiencia-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="extroversao" style={{ fontWeight: "bold" }}>
                    {" "}
                    4. Propensão à Extroversão:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial que tende a ser mais aberto e expressivo.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/extroversão-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <h3 id="afinidades">Afinidades a Tipo de Ofertas</h3>
                </p>

                <p>
                  Veja os tipos de afinidades a tipo de ofertas que você pode
                  utilizar.
                </p>

                <p>
                  <a id="custobeneficio" style={{ fontWeight: "bold" }}>
                    {" "}
                    1. Custo benefício:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial que tenha preferência a produtos ou serviços com
                  ótimo custo benefício.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/custo-beneficio-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="consumoonline" style={{ fontWeight: "bold" }}>
                    {" "}
                    2. Influência de Consumo On-line:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial que tenha uma forte influência em atividades e
                  opiniões on-line na hora de adquirir um produto ou serviço.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/influencia-consumo-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="estabilidade" style={{ fontWeight: "bold" }}>
                    {" "}
                    3. Estabilidade:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial que exibe consistência, equilíbrio e resiliência em
                  várias áreas de sua vida.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/estabilidade-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="statussocial" style={{ fontWeight: "bold" }}>
                    {" "}
                    4. Status social:{" "}
                  </a>
                  Utitize essa variável para segmentar ou criar um público
                  potencial que tende a adquir um produto ou serviço prezando
                  status social, buscando formas de aumentar sua posição na
                  hierarquia social e de ser percebida como bem-sucedida,
                  influente e respeitada dentro de sua comunidade ou grupo
                  social.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/status-social-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="experienciacompra" style={{ fontWeight: "bold" }}>
                    {" "}
                    5. Experiência de Compra:{" "}
                  </a>
                  Utilize essa vriável para segmentar ou criar um públco
                  potencial que pbusca uma jornada de compra que vá além da
                  simples transação comercial, priorizando aspectos como
                  conforto, conveniência, atendimento de qualidade e
                  personalização, a fim de tornar a experiência de compra o mais
                  agradável e satisfatória possível.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/esperiencia-compra-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="facilidadepagamento" style={{ fontWeight: "bold" }}>
                    {" "}
                    6. Facilidade de Pagamento:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial que dá peferência para a facilidade de pagamento.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/facilidade-pagamento-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="conveniencia" style={{ fontWeight: "bold" }}>
                    {" "}
                    7. Conveniência:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial com tendência a utilizar lojas de conveniência.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/conveniencia-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="premium" style={{ fontWeight: "bold" }}>
                    {" "}
                    8. Premium:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial com tendência a adquirir produtos premium.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/premium-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="varejo" style={{ fontWeight: "bold" }}>
                    {" "}
                    9. Varejo Físico:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial com tendência a preferir lojas físicas.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/varejo-fisico-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="consumodigital" style={{ fontWeight: "bold" }}>
                    {" "}
                    10. Consumo Potencial Digital:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial que demonstra uma preferência por adquirir produtos
                  ou serviços por meio de canais digitais, aproveitando as
                  vantagens de conveniência, variedade e segurança oferecidas
                  pelo comércio eletrônico.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/consumo-digital--publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="premiumservico" style={{ fontWeight: "bold" }}>
                    {" "}
                    11. Premium Serviço:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial com tendência a adquirir serviços premium.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/premium-service-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="esg" style={{ fontWeight: "bold" }}>
                    {" "}
                    12. ESG (Ambiental, Social e Governamental):{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial com tendência a valorizar empresas com práticas
                  ambientais, sociais e de governança.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img src="img/esg-publico-potencial.png" alt="integracao" />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="consumooffline" style={{ fontWeight: "bold" }}>
                    {" "}
                    13. Influência de Consumo Off-line:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial com tendência a ser influenciado por meios físicos
                  (revistas, jornais, rádio).
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/consumo-offline-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="conscienciosidade" style={{ fontWeight: "bold" }}>
                    {" "}
                    14. Propensão à Conscienciosidade:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial com tendência a traços psicológicos de
                  autodisciplina, organização, metódicos.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/conscienciosidade-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="brinde" style={{ fontWeight: "bold" }}>
                    {" "}
                    15. Brinde:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial com tendência a adquirir um produto ou serviço se
                  estiver associado a um brinde.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/brinde-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="instabilidade" style={{ fontWeight: "bold" }}>
                    {" "}
                    16. Instabilidade:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial com tendência a exibir comportamentos e emoções
                  voláteis, imprevisíveis ou inadequados em diversas situações.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/instabilidade-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="opçãopagamento" style={{ fontWeight: "bold" }}>
                    {" "}
                    17. Opção Pagamento:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial com tendência a ser influenciado por empresas que
                  oferecem diversos tipos de pagamento.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/opcao-pagamento-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="vantagemeco" style={{ fontWeight: "bold" }}>
                    {" "}
                    18. Vantagem Econômica:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial com tendência a buscar produtos ou serviços com
                  vantagem econômica.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/vantagem-economica-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="sazonal" style={{ fontWeight: "bold" }}>
                    {" "}
                    19. Valor Sazonal:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial com tendência a compra de produtos em datas
                  comemorativas.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/valor-sazonal-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="inovacao" style={{ fontWeight: "bold" }}>
                    {" "}
                    20. Inovação:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial que possui uma forte inclinação para buscar e adotar
                  novas ideias, métodos, tecnologias ou abordagens em diversas
                  áreas da vida.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/inovacao-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="confiacamarca" style={{ fontWeight: "bold" }}>
                    {" "}
                    21. Confiança de Marca:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial com tendência a confiar nas marcas.
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/confianca-marca-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <a>
                <MenuInicioRapido />
              </a>
              <br></br>
              <br></br>
              <small>
                <PalavraChavePsicografica />
              </small>
            </div>
          </div>
        </div>

        {showScrollButton && (
          <a onClick={scrollToTop} className="btn-topo">
            <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
          </a>
        )}
      </section>
      <Footer />
    </>
  );
}
